export default __webpack_public_path__ + "static/media/Jay Vaingankar.cb5a8e3b.jpg";